import axios from "axios";

// Configura la instancia de Axios
const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL, 
});

// Interceptor para añadir el token en las cabeceras
api.interceptors.request.use((config) => {
    // Captura el token del localStorage
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
}, (error) => {
    return Promise.reject(error);
});

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
    (response) => {
        return response; // Retorna la respuesta si todo está bien
    },
    (error) => {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // Redirige al usuario a /login si el token no es válido o ha expirado
            localStorage.removeItem("user"); // Limpia el token
            window.location.href = "/login"; // Redirige al login
        }
        return Promise.reject(error); // Retorna el error para manejarlo en el componente si es necesario
    }
);

export default api;